import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export interface CrossSell {
  payment: {
    expirationDate: string;
    paymentTokenId: string;
    paymentType: string;
    requestID: string;
    bankInfo: { type: string; accountNumber: string; routingNumber: string };
  };
  purchasedProducts: string[];
}

const defaultValues: CrossSell = {
  payment: {
    expirationDate: '',
    paymentTokenId: '',
    paymentType: '',
    requestID: '',
    bankInfo: { type: '', accountNumber: '', routingNumber: '' },
  },
  purchasedProducts: [],
};

const storage = createJSONStorage<CrossSell>(() => sessionStorage);
export const crossSell = atomWithStorage<CrossSell>(
  'crossSellInfo',
  defaultValues,
  storage
);

export const isCrossSellAtom = atom((get) => {
  const crossSellState = get(crossSell);
  return crossSellState.purchasedProducts.length > 0;
});
